import Axios from 'axios';

export default class ApiCaller {
    constructor(props) {
        this.headers = {};

        if (props.authState && props.authState.username && props.authState.username !== "")
            this.headers.sender = props.authState.username;

        if (props.authState && props.authState.token && props.authState.token !== "")
            this.headers["Authorization"] = `Bearer ${props.authState.token}`;

        if (props.authState && props.authState.div_code && props.authState.div_code !== "")
            this.headers["div"] = props.authState.div_code;
    }

    get(url) {
        if (this.headers.sender || this.headers["Authorization"] || this.headers["div"])
            return Axios.get(`${process.env.REACT_APP_EXTERNAL_API_ENDPOINT}${url}`, {headers: this.headers});
        
        return Axios.get(`${process.env.REACT_APP_EXTERNAL_API_ENDPOINT}${url}`);
    }

    post(url, data) {
        if (this.headers.sender || this.headers["Authorization"] || this.headers["div"])
            return Axios.post(`${process.env.REACT_APP_EXTERNAL_API_ENDPOINT}${url}`, data, {headers: this.headers});
        
        return Axios.post(`${process.env.REACT_APP_EXTERNAL_API_ENDPOINT}${url}`, data);
    }

    put(url, data) {
        if (this.headers.sender || this.headers["Authorization"] || this.headers["div"])
            return Axios.put(`${process.env.REACT_APP_EXTERNAL_API_ENDPOINT}${url}`, data, {headers: this.headers});

        return Axios.put(`${process.env.REACT_APP_EXTERNAL_API_ENDPOINT}${url}`, data);
    }

    delete(url) {
        if (this.headers.sender || this.headers["Authorization"] || this.headers["div"])
            return Axios.delete(`${process.env.REACT_APP_EXTERNAL_API_ENDPOINT}${url}`, {headers: this.headers});
        
        return Axios.delete(`${process.env.REACT_APP_EXTERNAL_API_ENDPOINT}${url}`);
    }
};
